import * as Yup from 'yup'

export const emarsysNewsletterSchema = Yup.object().shape({
  inp_46: Yup.string().required('forms.errors.salutation'),
  inp_1: Yup.string().required('forms.errors.firstName'),
  inp_2: Yup.string().required('forms.errors.lastName'),
  inp_3: Yup.string().email('forms.errors.email').required('forms.errors.emailRequired'),
  optin: Yup.bool().oneOf([true], 'forms.errors.termsAndConditions'),
})
